jQuery(document).on("page.ready", function() {
  $ = jQuery;

  if ($("section.instagram-feed").length) {
    var smcontroller = new ScrollMagic.Controller();
    // IG Feed Slider
    var $feedSlider = $(".ig-feed-container .owl-carousel");
    $feedSlider.owlCarousel({
      autoplay: false,
      autoplayTimeout: 6000,
      autoplaySpeed: 600,
      autoplayHoverPause: true,
      loop: true,
      nav: false,
      slideBy: 2,
      items: 1,
      margin: 0,
      dots: false,
      lazyLoad: true,
      responsive: {
        575: {
          items: 2
        },
        950: {
          items: 3
        },
        1200: {
          items: 4
        }
      }
    });

    // Go to the prnextevious item
    $(".ig-next").click(function() {
      $feedSlider.trigger("next.owl.carousel");
    });
    // Go to the previous item
    $(".ig-prev").click(function() {
      $feedSlider.trigger("prev.owl.carousel");
    });

    $(window).on("load resize", function() {
      var $gramWidth = $(".gram img").width(),
        $gram = $(".gram");
      $gram.height($gramWidth - 2);
    });
  }
});
